const draw_shape = require('../class/shapes.js')
let api             = require('@/api.js');

class poligon{
	constructor(context, roi, radius, text){
		 // info
        this.info_polygon   = {};
        this.roi        	= roi;
        this.context    	= context;
		// draw polygon
        this.nodeIndex   	= null;
        this.nodeRadius  	= radius;//5;
        this.context_point 	= null;
        this.points 		= [];
        this.polygon 		= [                
            /*[20, 20],
            [150, 25],
            [150, 289],
            [50, 190]*/
        ];
        this.camPoints              = null;
        this.camImage               = new Image();
        this.camImage.src           = (api && api.isdocker ? api.ext : "/") + 'img/tags/cam/camera_blue.png';        
        this.init_pos_polygon       = 4;
        this.number_point_polygon   = 3;        
        this.text 					= text;
        this.clear_draw 			= null;
        this.current_width          = null;
        this.current_height         = null;
        this.segment_width          = null;
        this.segment_height         = null;
        this.segment_x              = null;
        this.segment_y              = null;
        this.bus                    = null;
        this.EventBus               = null;
        this.bus                    = {
            listen      : null,
            connection  : null,
            alert       : null,
        };
        this.isAlertActive          = false;
        this.time_alert             = null;

        this.set_sizes(roi);
       

        // this.drawing(this.roi, text);


	}

    set_sizes(size){
        if (size) {
            if (size.width) {
                this.current_width  = size.width;
            }
            if (size.height) {
                this.current_height = size.height
            }
        }
    }

    set_color(){
        // colors and line
        // roi_context.lineWidth = 2; 

        // color ramdom
        let o    = Math.round, r = Math.random, s = 255;
        let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
        let num1 = o(r()*s)
        let num2 = o(r()*s)
        let num3 = o(r()*s)
        

        this.context.strokeStyle =  'rgba('+num1+','+num2+','+num3+',0.5)';//'#ffffff';
        this.context.fillStyle   = 'rgba('+num1+','+num2+','+num3+',0.3)';//'#00ff00';
        this.context.lineWidth   = 3; // line width
    } // set color

	// set poing for use should before draw
    set_points(num){
        this.number_point_polygon = num;
    }

    // add  new point polygon
    add_points(num = 1){
        this.number_point_polygon += num;   
    }


    set_eventBus(eventBus){
        this.EventBus = eventBus;
    }

    setCamPoints(points){
        this.camPoints = points;
    }

    // get position x y mouse
    getMousePos(canvas, evt) {
        let rect = canvas.getBoundingClientRect();
        // console.log(rect, 'rect')
        return {
            x: parseInt((evt.clientX - rect.left) / (rect.right - rect.left) * canvas.width),
            y: parseInt((evt.clientY - rect.top) / (rect.bottom - rect.top) * canvas.height)                
        };
    } // getMousePos



	drawPolygon(ctx, poly, roi, idx){ // nodeRadius
		
        
        /*if (this.list && this.list.length > 0 && this.list[idx]) {            
            this.list[idx].polygon = poly;
        }*/
        // console.log(ctx, poly, nodeRadius, roi, idx)
        
        ctx.beginPath();
        let x, y;


        // draw area
        for (let index in poly) {
            x = poly[index][0];
            y = poly[index][1];
            ctx.lineTo(x, y);
        }

        ctx.closePath();
        ctx.stroke();
        ctx.fill();
        

        let temp_fill   = ctx.fillStyle,
            temp_stroke = ctx.strokeStyle;

        // ctx.fillStyle = 'white';
        // ctx.fillRect(x, y, this.text.length, 20);
        // ctx.shadowColor = 'black';
        // ctx.shadowBlur = 5;
        ctx.font      = "16px Georgia";
        ctx.fillStyle = "rgba(0,0,0,1)";                
        // console.log("TEXT ============== ", this.text)
        ctx.fillText(this.text,   x + 20, y-5 );
     /*   ctx.shadowColor = 'transparent';
        ctx.shadowBlur = 0;*/
        // console.log("TEXT ", this.text)


        
        // draw points
        for (let index in poly) {
            x = poly[index][0];
            y = poly[index][1];
            ctx.beginPath();
            ctx.fillStyle   = '#000000'//'#ffffff' //
            ctx.strokeStyle = '#000000'//'#00ff00'
            ctx.arc(x, y, this.nodeRadius, 0, Math.PI * 2, 1);
            ctx.fill();

        }
        

        ctx.fillStyle   = temp_fill;
        ctx.strokeStyle = temp_stroke;

        this.setRelativeCoords(poly, roi, idx);
    } // drawPolygon

    setRelativeCoords(info_polygon, roi, idx){
		
        let pointss = [];
        
        for(let iter in info_polygon){                
            pointss.push([(info_polygon[iter][0] / roi.width).toFixed(4), 
                        (info_polygon[iter][1] / roi.height).toFixed(4)]);
        }
        this.points   	= pointss;
        this.polygon 	= info_polygon;

    }

    getCoords(){
    	return this.polygon;
    }
    getRelativeCoords(){
    	return this.points;
    }

    get_color_random(){
        let o    = Math.round, 
            r    = Math.random, 
            s    = 255;
        // let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
        let num1 = o(r()*s)
        let num2 = o(r()*s)
        let num3 = o(r()*s)
        return 'rgba('+num1+','+num2+','+num3+',0.5)';
    }
    check_segment(){
        // console.log("check segment canv");
        let poly = this.polygon;

        if (poly && poly[0] && poly[0][0] && poly[0][1]) {

            let X = poly[0][0],
                Y = poly[0][1],
                W = 0,
                H = 0;
            /*
                0 => x
                1 => y

            */
            for (let iter of poly){
                // console.log(iter);
                if (iter[0] <= X) {
                    X = iter[0];
                    // console.log("X", iter)
                }
                if (iter[1] <= Y) {
                    Y = iter[1] 
                    // console.log("Y" ,iter)
                }
                if (iter[0] >= W){
                    W = iter[0];
                    // console.log("W" ,iter)
                }   
                if (iter[1] >= H) {
                    H = iter[1];
                    // console.log("H" ,iter)

                }
                
            }
            // console.log(X, Y , H , W);
            this.segment_width  = W - X;
            this.segment_height = H;
            this.segment_x      = X;
            this.segment_y      = Y;
        }

    }


    close_bus(){
        if (this.bus && this.bus.listen) {
            let { listen , connection } = this.bus;
            this.EventBus.$off(listen, connection);
            // console.log("close connection bus polygon ", this.text);
        }else{
            console.log("Not connection to close ", this.text);
        }
    }   // close bus

    start_bus(listen, draw_setting, tags, deviceId){
        // console.log("start bus polygon")
        this.bus.listen		= listen;
        let vm 				= this;
        this.clear_draw 	= null;
        let line_width 		= draw_setting && draw_setting.parameters && draw_setting.parameters.line_width ? parseInt(draw_setting.parameters.line_width) : 2 ;
        let draw_colors     = draw_setting && draw_setting.list && draw_setting.list.length > 0 ? draw_setting.list : null;
        let image_tag       = tags;
        this.check_segment();
        /*let test = new Image();
        test.src ='/img/tags/person/green.png';*/
        let size_tag  = {
            w : 20,
            h : 20,
        };
        let temp_color = {
          stroke : vm.context.strokeStyle,  
          fill   : vm.context.fillStyle,
        };
        let shp = new draw_shape(
            (0.3 *  (parseInt(vm.segment_width))) + parseInt(vm.segment_x),
            0.3 *  (parseInt(vm.segment_height)) + parseInt(vm.segment_y),
            0.3 *  parseInt(vm.segment_width),
            0.3 *  parseInt(vm.segment_height)
            );
        
        

        let timer_alert = null;
        let temp_bus    = "Alert" + deviceId; 
        this.EventBus.$on(temp_bus, vm.bus[temp_bus] = (action)=>{
            vm.context.clearRect(0, 0, vm.current_width, vm.current_height );
            // let tag         = action && action.tag ? action.tag : "Alert"; 
            let color_ramd  = 'rgba('+255+','+0+','+0+',1)'; //vm.get_color_random();
            
            let fx = (0.3 *  (parseInt(vm.segment_width))) + parseInt(vm.segment_x) ;
            let fy = 0.3  *  (parseInt(vm.segment_height)) + parseInt(vm.segment_y); 
            let w  = 0.3  *  parseInt(vm.segment_width);
            let h  = 0.3  *  parseInt(vm.segment_height);
            fx = Math.abs(fx)
            fy = Math.abs(fy)
                        
            if (fx >= vm.segment_x + vm.segment_width) {
                fx = (vm.segment_x + vm.segment_width) - size_tag.w; 
            }else{
                if (fx <= vm.segment_x) {
                    fx = vm.segment_x;
                }
            }
            if (fy >= vm.segment_height) {
                fy = vm.segment_height - (size_tag.h * 2);
            }else{
                if (fy <= vm.segment_y) {
                    fy = vm.segment_y;
                }
            }


            if (fx >= vm.segment_x && fy >= vm.segment_y &&  
                fx <=  vm.segment_x + vm.segment_width && 
                fy <= vm.segment_height ) {
                // shp.addShappe(vm.context, 'warning', 'yellow', tag , false, 1800);
                if (image_tag && image_tag["alert"]) {
                    vm.context.drawImage(image_tag["alert"], fx, fy, size_tag.w, size_tag.h)
                    vm.activeAlertTime(action);
                    vm.reDrawCamera(vm.context);

                }
                // vm.context.drawImage(image_tag[element.tag], fx, fy, size_tag.w, size_tag.h)
               
                if (action && action.formated && action.formated.tag) {

                    vm.context.font      = "12px Georgia";
                    vm.context.fillStyle = "rgba(0,0,0,1)";
                    vm.context.fillText(
                        action.formated.tag, 
                        fx + 20, 
                        fy + 20)//(element.bbox.x*factorx)+20, (element.bbox.y*factory)+20);
                }
                /*aux = {
                  x : fx * parseInt(vm.segment_width),
                  y : fy * parseInt(vm.segment_height),
                  w : 0.5 * parseInt(vm.segment_width),
                  h : 0.5 * parseInt(vm.segment_height)
                }*/
            }
            
        
            timer_alert = setTimeout(()=>{
                vm.context.clearRect(0, 0, vm.current_width, vm.current_height );

                vm.context.strokeStyle  = temp_color.stroke;
                vm.context.fillStyle    = temp_color.fill;
                vm.drawPolygon(vm.context, vm.polygon, vm.roi);
                vm.reDrawCamera(vm.context);

                clearTimeout(timer_alert)
            }, 3000)
        });

        this.EventBus.$on(listen, vm.bus.connection = (action)=>{
            if (action) {

            	let msg = action;
            	if (msg && msg.analytics_results && 
                    msg.analytics_results.length > 0 && 
                    msg.analytics_results[0] && msg.analytics_results[0].bbox) {

		            if (vm.clear_draw) {
		                clearTimeout(vm.clear_draw);
		                vm.clear_draw = null;
		            }


		            let exs = msg;

		            vm.context.clearRect(0, 0, vm.current_width, vm.current_height );

		            if (exs.analytics_results && exs.analytics_results.length > 0){
		                let aux = {};
    		            exs.analytics_results.forEach(function (element, index, array) {
    		                if (element) {


                                if (element.bbox) {

        		                 let o    = Math.round, r = Math.random, s = 255;
        		                 let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
        		                 let num1 = o(r()*s)
        		                 let num2 = o(r()*s)
        		                 let num3 = o(r()*s)
        		             
        		                
        		                let color_set    = 'rgba('+num1+','+num2+','+num3+',0.5)';
        		                
        		                if (draw_colors) {
        		                  const find_color = draw_colors.some( (tag_color => {
        		                    if (tag_color.tag == element.tag) {
        		                      color_set = tag_color.color;
        		                      return true
        		                    }
        		                  })) 
        		                }

        		                // width line
        		                vm.context.lineWidth   = line_width;                

        		                // color stroke / fill 
        		                vm.context.strokeStyle = color_set;
        		                
        		                
        		                let fx = (element.bbox.x *  (parseInt(vm.segment_width))) + parseInt(vm.segment_x) ;
                                
        		                let fy = element.bbox.y *  (parseInt(vm.segment_height)) + parseInt(vm.segment_y); 
                                
        		                let w  = element.bbox.w *  parseInt(vm.segment_width);
        		                let h  = element.bbox.h *  parseInt(vm.segment_height);
                               /* console.log("relative X : ",  
                                    element.bbox.x, 
                                    "\n small box w : ", parseInt(vm.segment_width),
                                    "\n small box x : ", parseInt(vm.segment_x),
                                    "\n width total :", vm.current_width
                                    )
                                console.log("relative Y : ",  
                                    element.bbox.y, 
                                    "\n small box h : ", parseInt(vm.segment_height),
                                    "\n small box y : ", parseInt(vm.segment_y),
                                    "\n height total :", vm.current_height
                                    )*/
            		                // console.log(fx, fy, w, h, element.tag);

        		                fx = Math.abs(fx)
        		                fy = Math.abs(fy)
        		                
        		                // draw 
        		                //vm.context.strokeRect(fx, fy, w, h); // fill
                                // console.log("draw image ", element.tag,  fx, fy)
                                
                                // fy -= size_tag.w;
                                /*console.log(element.tag, 
                                    "\n current X  : ", fx , " >= X ", vm.segment_x, 
                                    "\n current Y  : ", fy , " >= Y ", vm.segment_y,  
                                    "\n W  : ", vm.segment_x + vm.segment_width, " | ", vm.segment_x , vm.segment_width,
                                    "\n H  : ", vm.segment_y + vm.segment_height, " | ", vm.segment_y , vm.segment_height);*/
                                if (fx >= vm.segment_x + vm.segment_width) {
                                    fx = (vm.segment_x + vm.segment_width) - size_tag.w; 
                                }else{
                                    if (fx <= vm.segment_x) {
                                        fx = vm.segment_x;
                                    }
                                }
                                if (fy >= vm.segment_height) {
                                    fy = vm.segment_height - (size_tag.h * 2);
                                }else{
                                    if (fy <= vm.segment_y) {
                                        fy = vm.segment_y;
                                    }
                                }


                                if (fx >= vm.segment_x && fy >= vm.segment_y &&  
                                    fx <=  vm.segment_x + vm.segment_width && 
                                    fy <= vm.segment_height ) {

                                    if (vm.context) {                                        
                                        if (vm.isAlertActive && image_tag["alert"] && 
                                            image_tag["alert"].complete && image_tag["alert"].naturalWidth !== 0) {                                        
                                            vm.context.drawImage(image_tag["alert"], fx, fy, size_tag.w, size_tag.h)
                                        }else if (image_tag && element.tag && image_tag[element.tag] && 
                                                 image_tag[element.tag].complete && image_tag[element.tag].naturalWidth !== 0) {
                                            vm.context.drawImage(image_tag[element.tag], fx, fy, size_tag.w, size_tag.h)
                                        }
                                    }
            		               
                                    vm.context.font      = "12px Georgia";
            		                vm.context.fillStyle = "rgba(0,0,0,1)";
            		                vm.context.fillText(
                                        element.tag, 
                                        fx + 20, 
                                        fy + 20)//(element.bbox.x*factorx)+20, (element.bbox.y*factory)+20);
            		                aux = {
            		                  x : fx * parseInt(vm.segment_width),
            		                  y : fy * parseInt(vm.segment_height),
            		                  w : element.bbox.w * parseInt(vm.segment_width),
            		                  h : element.bbox.h * parseInt(vm.segment_height)
            		                }
                                }
        		                
        		                
        		                      
        		                }
                            }
    		            }); // forEach
                        vm.context.strokeStyle = temp_color.stroke;
                        vm.context.fillStyle = temp_color.fill;
                        vm.drawPolygon(vm.context, vm.polygon, vm.roi);
                        vm.reDrawCamera(vm.context);

		            }
		                vm.clear_draw = setTimeout(()=>{
		                    vm.context.clearRect(0, 0, vm.current_width, vm.current_height );
                            vm.context.strokeStyle = temp_color.stroke;
                            vm.context.fillStyle = temp_color.fill;
                            vm.drawPolygon(vm.context, vm.polygon, vm.roi)
                            vm.reDrawCamera(vm.context);
		                    clearTimeout(vm.clear_draw);
		                }, 5000);

		          
		          }

            }
        });
    }

    reDrawCamera(context){
        if(this.camPoints && this.camImage && this.camImage.complete && this.camImage.naturalWidth !== 0){            
            const coords = this.convertRelativeToCoords(this.camPoints);
            if (coords && coords.length > 0 && coords[0]) {
                context.drawImage(this.camImage, coords[0][0]-10, coords[0][1]-10, 30, 30)
            }
        }
    }
    convertRelativeToCoords(coords){ // for Camera 
        if (coords && coords.length > 0) {
            let points = [];            
            coords.forEach((point)=>{
                if (point[0] && point[1] && !point.includes('NaN')) {                            
                    points.push([point[0] * this.current_width , (point[1]) * this.current_height])
                }
            });
            if (points.length > 0) {
                return points;
            }
        }
        return null;
    }
    activeAlertTime(item){
        if (item) {
            let time = 5000;
            if (item.alert) {
                if (item.alert.timeout) {
                    time = item.alert.timeout;
                }else if(item.alert.timeoutAlert){
                    time = item.alert.timeoutAlert;
                }
            }
            if (!this.time_alert) {
                this.isAlertActive  = true;
                this.time_alert     = setTimeout(()=>{
                    this.isAlertActive  = false;
                    clearTimeout(this.time_alert);
                    this.time_alert     = null;
                }, time*1000);
            }
        }
        
    }

    // Método para limpiar recursos del canvas
    cleanup() {
        // Limpiar timers
        if (this.time_alert) {
            clearTimeout(this.time_alert);
            this.time_alert = null;
        }
        
        // Limpiar context
        if (this.context) {
            this.context.clearRect(0, 0, this.current_width, this.current_height);
            this.context = null;
        }
        
        // Limpiar event bus listeners
        if (this.EventBus && this.bus) {
            for (let eventName in this.bus) {
                if (this.bus[eventName]) {
                    this.EventBus.$off(eventName, this.bus[eventName]);
                }
            }
            this.bus = {};
        }
        
        // Limpiar variables
        this.isAlertActive = false;
        this.polygon = null;
        this.roi = null;
    }

    drawing(canv, idx){
    	console.log("init listeners ");
    	let vm = this;
    	canv.addEventListener('mousedown', function(event){
    		console.log('mousedown : ',idx)
            const mousePos  = vm.getMousePos(vm.roi, event);
            // console.log("side *****************+ ",side , mousePos, current_width. current_height, roi)
                let find = false;
                let dx, dy, x, y, d; 
                for (let index in vm.polygon) {
                    x  = vm.polygon[index][0];
                    y  = vm.polygon[index][1];
                    dx = Math.abs(mousePos.x -x/*event.clientX - roi.offsetLeft - x*/);
                    dy = Math.abs(mousePos.y -y/*event.clientY - roi.offsetTop - y*/);
                    d  = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    if (d < vm.nodeRadius) {
                        console.log(d , "NODE RADIUS")
                        find = true;
                        vm.nodeIndex = index;                                  
                        break;
                    }
                }   
                console.log(d , "NODE RADIUS", find)

                /*.left
                .right
                .middle*/
                if (false /*!find*/) {

                    vm.list.some( (poly, idx_poly) =>{
                        // let dx, dy, x, y, d; 
                        console.log("check point", poly , poly.name , poly.polygon/*, poly.polygon ,poly.draw.polygon */)
                        let polygons = poly.polygon && poly.polygon.length > 0 ? 
                                        poly.polygon : 0; 

                        if (polygons && polygons.length > 0) {
                            
                            for (let index in polygons) {
                                x  = polygons[index][0];
                                y  = polygons[index][1];
                                dx = Math.abs(mousePos.x -x);/*event.clientX - roi.offsetLeft - x*/
                                dy = Math.abs(mousePos.y -y);/*event.clientY - roi.offsetTop - y*/ 
                                d  = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                                console.log(d , " < ", vm.nodeRadius, poly.name);
                                if (d < vm.nodeRadius) {
                                    console.log(d , "NODE RADIUS 2")
                                    vm.nodeIndex = index;
                                    vm.idx_point = idx_poly;
                                    vm.polygon   = polygons;
                                    vm.roi       = poly.roi;
                                    vm.context   = poly.context;
                                    return true;
                                    break;
                                }
                            }   
                        }
                    })
                }
          
        }, false);
    	

    	canv.addEventListener('mousemove', function(event){
            let top, left;
            let mousePos = vm.getMousePos(vm.roi, event);             
              if (vm.nodeIndex != null) {
                // roi_context = context_point;
                vm.context.clearRect(0, 0, vm.current_width, vm.current_height);
                vm.polygon[vm.nodeIndex][0] = mousePos.x; // event.clientX;
                vm.polygon[vm.nodeIndex][1] = mousePos.y; //event.clientY;

                vm.drawPolygon(
                    vm.context, 
                    vm.polygon , 
                    vm.nodeRadius, 
                    vm.roi, 
                    vm.idx_point
                );
            }
		}, false);

		canv.addEventListener('mouseup', function(event){
            
            let mousePos = vm.getMousePos(vm.roi, event);
            vm.nodeIndex = null;
            
        }, false);
    }
}

module.exports = poligon